module.exports = __webpack_public_path__ + "./docs/img/icon-root.47cff2f09074149c32260aafb738c3f6.svg";